module.exports = __webpack_public_path__ + "img/icon_googleplay.6d30dba6.png";